import { render, staticRenderFns } from "./PeoplePullout.vue?vue&type=template&id=13266dc1&scoped=true&"
import script from "./PeoplePullout.vue?vue&type=script&lang=js&"
export * from "./PeoplePullout.vue?vue&type=script&lang=js&"
import style0 from "./PeoplePullout.vue?vue&type=style&index=0&id=13266dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13266dc1",
  null
  
)

export default component.exports